ChangeBoardPermsView = require 'app/scripts/views/board-menu/change-board-perms-view'

module.exports = class ChangeBoardCommentingPermsView extends ChangeBoardPermsView
  viewTitleKey: 'commenting permissions'
  getTemplate: -> require('app/scripts/views/templates/board_menu_commenting')
  getPerm: -> 'comments'
